'use strict';

import axios from 'axios';
import * as dom from './lib/dom.js';

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

const debouncedLoadResults = debounce(() => {
    const input = document.querySelector('#global-search-input');
    const value = input.value.trim();
    let mainUrl = input.getAttribute('data-url');
    const loading = document.querySelector('.c-search-load');
    const loadingError = document.querySelector('.c-search-load__error');
    const feedback = document.querySelector('.c-search-response');
    const feedbackParagraph = document.querySelector('.c-search-response p');
    const searchBox = document.querySelector('.c-search-box-wrapper');
    const searchSeeMore = document.querySelector('.js-search-box__button');

    dom.addClass(loading, 'c-search-load--active');

    if (mainUrl.search('is_podcast_section=true') !== -1) {
        mainUrl =  mainUrl + '&is_ajax=true&s=';
    } else {
        mainUrl =  mainUrl + '/?is_ajax=true&s=';
    }

    axios
        .get(mainUrl + encodeURI(input.value))
        .then(response => {
            // console.log(response);
            dom.removeClass(loading, 'c-search-load--active');
            dom.addClass(feedback, 'c-search-response--active');
            dom.addClass(searchBox, 'c-search-box-wrapper--active');
            dom.removeClass(searchSeeMore, 'u-hidden');
            feedback.innerHTML = response.data;
            setTimeout(function(){
                input.blur();
            }, 1000);
        })
        .catch(error => {
            dom.removeClass(loading, 'c-search-load--active');
            dom.addClass(loadingError, 'c-search-load__error--active');

            loadingError.innerHTML = error;

            console.log('loadSearchPreview error:', error);

            setTimeout(function(){
                input.blur();
            }, 1000);
        });
}, 700);

const handleKeyup = e => {
    const value = e.target.value.trim();
    const searchBox = document.querySelector('.c-search-box-wrapper');
    const responseBox = document.querySelector('.c-search-response');

   

    if (value === '') {
        dom.removeClass(searchBox, 'c-search-box-wrapper--active');
        dom.addClass(searchSeeMore, 'u-hidden');

        while( responseBox.hasChildNodes() ){
            responseBox.removeChild(responseBox.lastChild);
        }
        return;
    }

    debouncedLoadResults();
};


export default function() {
    const input = document.querySelector('#global-search-input');
    input.addEventListener('keyup', handleKeyup);
}
